module.exports = __webpack_public_path__ + "static/media/course4.44bc5696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parentreg/course4.png
// module id = 2844
// module chunks = 0